module.exports = __webpack_public_path__ + "static/media/www.barfredrik.fi.a6d0f709.png";